export default function Icon() {
	return (
		<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd"
				  d="M2.12017 5.53022L6.58984 9.99989L5.52918 11.0605L-0.00114679 5.53022L5.52918 -0.000112626L6.58984 1.06055L2.12017 5.53022Z"
				  fill="currentColor"/>
		</svg>
	);
}
